import React from "react";
import Tbody from "./Tbody";
import Thead from "./Thead";
import NoDataFound from "../../common/NodataFound";
import { classNames } from "../../../helpers/classNames";
import Pagination from "../../common/Pagination";
import { handleOnDragEnd } from "../../../helpers";
import { DragDropContext } from "@hello-pangea/dnd";
import TableSkeleton from "../../skeleton/TableSkeleton";

const Table = ({
  tableImage,
  tableData = [],
  tableHeadData = [],
  containerClasses,
  tableClasses,
  isLoder = true,
  onPageChange = () => {},
  pageCount,
  currentPage,
  list,
  setSelectedItems = () => {},
  selectedItems = [],
  isOrderingDisabled = true,
  handleOrdering = () => {},
  setOriginalData = () => {},
  isCheckbox = false,
  originalData = [],
  tableActionDropdownContainer,
  isFetching = false,
}) => {
  const whiteStripe =
    "after:content-[''] after:absolute after:right-0 after:top-0 after:w-6 after:h-full after:z-[1] after:bg-white";
  const colspan = tableHeadData.length;

  const onDragEnd = (result) => {
    handleOnDragEnd(result, originalData, setOriginalData, (val) => {
      handleOrdering(val, originalData);
    });
  };

  const selectAllCheckBox = () => {
    if (selectedItems.length === tableData.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(tableData.map((item, index) => item._id));
    }
  };

  const heandleCheckboxSelection = (item) => {
    setSelectedItems((items) =>
      items.includes(item._id)
        ? items.filter((filterItem) => filterItem !== item._id)
        : [...items, item._id]
    );
  };

  if (isCheckbox) {
    if (!(tableHeadData[0].type === "checkbox")) {
      tableHeadData.unshift({
        _id: crypto.randomUUID(),
        type: "checkbox",
        name: "",
        align: "left",
        isSort: false,
        isFilter: false,
        thClasses: "w-[1%] !bg-black/5",
        checked: selectedItems.length
          ? selectedItems.length === tableData.length
          : false,
        onCheckboxChange: selectAllCheckBox,
      });
    }
    tableData?.forEach((element) => {
      const rowData = element.rowData;
      if (rowData[0].type !== "checkbox") {
        let obj = {
          _id: crypto.randomUUID(),
          type: "checkbox",
          align: "left",
          data: "X",
          tdClasses: "w-[1%]",
          itemDetails: element,
          checked: selectedItems.includes(element._id),
          onCheckboxChange: heandleCheckboxSelection,
        };
        rowData.unshift(obj);
      }
    });
  }

  return (
    <div>
      <div
        className={classNames(
          "relative w-full overflow-auto rounded-md scroll-smooth  scrollbar ",
          pageCount > 1 ? "" : "pb-8",
          containerClasses
        )}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table
            className={classNames(
              "min-w-max w-full table-auto rounded-md shadow-md bg-white",
              tableClasses
            )}
          >
            <Thead tableHeadData={tableHeadData} />
            {!isLoder && (
              <Tbody
                tableData={tableData}
                list={list}
                isOrdering={isOrderingDisabled}
                tableActionDropdownContainer={tableActionDropdownContainer}
              />
            )}
          </table>
        </DragDropContext>
        {isFetching && !isLoder && (
          <div
            className={classNames(
              "absolute right-0 flex items-center gap-2 text-slate-500 font-medium text-sm",
              pageCount > 1 ? "bottom-9" : "bottom-0"
            )}
          >
            <i className="fa-duotone fa-solid fa-spinner-third animate-spin"></i>
            Fetching...
          </div>
        )}
        {isLoder && (
          <div className="w-full">
            <TableSkeleton tableImage={tableImage} />
          </div>
        )}

        {!isLoder && tableData?.length === 0 && (
          <div className="rounded-b-xl bg-white py-5">
            <NoDataFound />
          </div>
        )}
      </div>
      {pageCount > 1 && (
        <Pagination
          paginationClasses={"mt-5 !justify-end"}
          onPageChange={({ selected }) => {
            onPageChange(selected + 1);
          }}
          pageCount={pageCount}
          currentPage={currentPage - 1}
        />
      )}
    </div>
  );
};

export default Table;
